module.exports = __webpack_public_path__ + "img/order_invalid_pc.198dfd66.png";